import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { FeatureFlagsModule } from 'mojo-feature-flags';

import { BasicProgressCustomStepComponent } from '@modules/assigns/components/basic-progress-custom-step/basic-progress-custom-step.component';
import {
  AssignContainerComponent,
  CandidateRejectDropdownComponent,
  DynamicProgressComponent,
} from '@modules/assigns/containers';
import { FeedbackModule } from '@shared/feedback/feedback.module';
import { StepperModule } from '@shared/stepper/stepper.module';
import { ThumbModule } from '@shared/thumb/thumb.module';

import { HiringManagerSubmitButtonComponent } from './hiring-manager-submit/hiring-manager-submit-button.component';
import { MoveForwardButtonComponent } from './move-forward/move-forward-button.component';

const buttons = [
  AssignContainerComponent,
  BasicProgressCustomStepComponent,
  CandidateRejectDropdownComponent,
  DynamicProgressComponent,
  MoveForwardButtonComponent,
  HiringManagerSubmitButtonComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    StepperModule,
    CdkStepperModule,
    FeedbackModule,
    ThumbModule,
    MojoFeatureExtensionsModule,
    FeatureFlagsModule,
  ],
  declarations: [...buttons],
  exports: [...buttons],
})
export class AssignsButtonsModule {}
